const DomUtils = require('../../util/dom_utils');

const elementName = 'player-title';

module.exports = {
    showTitle: function(title, subtitle) {
        DomUtils.destroyElementByType('class', elementName);
        const html = require('./player_title.hbs')({title: title, subtitle: subtitle});

        const playerTitleElem = DomUtils.createElement('div', {
            attributes: {'class': elementName},
            innerHtml: html
        });

        // todo: DO NOT ATTACH TO BITDASH-CTRL
        DomUtils.waitForElement('class', 'bitdash-ctrl', function(success, elem) {
            if (success) {
                elem.appendChild(playerTitleElem);
            } else {
                throw Error('cant find elem');
            }
        });
    }
};



// WEBPACK FOOTER //
// ./src/modules/player_title/player_title.js